import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ContentProvider } from './context/ContentContext';
import Home from './pages/Home';
import LinkAnalyzer from './pages/LinkAnalyzer';
import SemiAutomateInternalLinkBuilding from './pages/SemiAutomateInternalLinkBuilding';
import TopNavbar from './components/TopNavbar';
import { AutomateProvider } from './context/AutomateContext';

function App() {
  return (
    <>
      <TopNavbar />
      <Router>
        <Routes>

          <Route path="/" element={<ContentProvider><Home /></ContentProvider>} />
          <Route path="/linking-to/:selected_post_slug/" element={<ContentProvider><LinkAnalyzer /></ContentProvider>} />


          <Route path="/semi-automate-internal-link-building" element={<AutomateProvider><SemiAutomateInternalLinkBuilding /></AutomateProvider>} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
